module.exports = __webpack_public_path__ + "static/media/bolt.2bc2590f.svg";